module.exports = __webpack_public_path__ + "static/media/pic-16.ce5fa27b.jpg";